// ui — 예약 도메인 공용 컴포넌트
export { default as PaymentTerms } from './PaymentTerms'
